import { useCountUp } from "use-count-up";
import { useMediaQuery, Theme } from "@mui/material";

const prettifyNumber = (value: number) => {
  if (value >= 1e9) {
    return { number: Number((value / 1e9).toFixed(1)), identifier: "B" };
  } else if (value >= 1e6) {
    return { number: Number((value / 1e6).toFixed(1)), identifier: "M" };
  } else if (value >= 1e3) {
    return { number: Number((value / 1e3).toFixed(1)), identifier: "k" };
  }
  return { number: value, identifier: "" };
};

export const useMetricValue = (value: number) => {
  const fullDisplay = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const { number, identifier } = prettifyNumber(value);

  const { value: result } = useCountUp({
    isCounting: true,
    end: fullDisplay ? value : number,
    duration: 3,
    decimalPlaces: fullDisplay || Number.isInteger(number) ? 0 : 1,
    decimalSeparator: ".",
    easing: "easeOutCubic"
  });

  if (value === 0) {
    return "0";
  }

  return fullDisplay ? result : `${result}${identifier}`;
};
